import React, { useState } from 'react';
import styles from './PasswordInput.module.css';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const PasswordInput = (props) => {
  const [passwordHide, setpasswordHide] = useState(true);
  const showPassword = () => setpasswordHide(!passwordHide);
  return (
    <div>
      <h4>Password</h4>
      <div className={styles.passwordField}>
        <input
          name={props.name}
          type={passwordHide ? 'password' : 'text'}
          className={styles.passwordArea}
          value={props.value}
          onChange={props.onChange}
          onKeyDown={props.onKeyDown}
        />
        <ShowPasswordLogo passwordHide={passwordHide} onClick={showPassword} />
      </div>
    </div>
  );
};

PasswordInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default PasswordInput;

export const ShowPasswordLogo = ({ passwordHide, onClick }) => {
  return (
    <span>
      {passwordHide
        ? <Tooltip title="Show Password">
          <span>
            <AiOutlineEye
              aria-label='show password'
              className={styles.showPasswordLogo}
              onClick={onClick}
            />
          </span>
        </Tooltip>
        : <Tooltip title="Hide Password">
          <span>
            <AiOutlineEyeInvisible
              aria-label='hide password'
              className={styles.showPasswordLogo}
              onClick={onClick}
            />
          </span>
        </Tooltip>
      }
    </span>
  );
};

ShowPasswordLogo.propTypes = {
  passwordHide: PropTypes.bool,
  onClick: PropTypes.func,
};
